import SearchLayout from './SearchLayout'

export default SearchLayout
